import type { CSSProperties, ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { usePannableCanvasContext } from './pannableCanvasContext'

type CanvasOverlayAnchor = 'viewport' | 'world'

type CanvasOverlayProps = {
  anchor?: CanvasOverlayAnchor
  x?: number
  y?: number
  className?: string
  style?: CSSProperties
  children: ReactNode
}

export const CanvasOverlay = ({
  anchor = 'viewport',
  x = 0,
  y = 0,
  className,
  style,
  children,
}: CanvasOverlayProps) => {
  const { overlayEl, worldToViewport } = usePannableCanvasContext()
  if (!overlayEl) return <>{children}</>

  if (anchor === 'world') {
    const localPoint = worldToViewport(x, y)
    const anchoredStyle: CSSProperties = {
      ...style,
      position: 'absolute',
      left: 0,
      top: 0,
      transform: `translate3d(${localPoint.x}px, ${localPoint.y}px, 0)`,
    }
    return createPortal(
      <div className={className} style={anchoredStyle} data-canvas-overlay-anchor="world">
        {children}
      </div>,
      overlayEl,
    )
  }

  return createPortal(
    <div className={className} style={style} data-canvas-overlay-anchor="viewport">
      {children}
    </div>,
    overlayEl,
  )
}
